// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-agenda-block {
  margin-bottom: 15px;
  --padding-start: 16px;
}
.skeleton-agenda-block__date {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 48px;
  margin-inline-end: 12px;
}
.skeleton-agenda-block__date ion-skeleton-text {
  margin: 0;
  width: 100%;
  height: 16px;
  border-radius: 4px;
}
.skeleton-agenda-block__date .skeleton-agenda-block__date-line {
  height: 12px;
}
.skeleton-agenda-block__label {
  margin: 0;
}
.skeleton-agenda-block__line {
  margin: 0 0 8px;
}
.skeleton-agenda-block__line ion-skeleton-text {
  margin: 0;
  height: 16px;
}
.skeleton-agenda-block__line--primary ion-skeleton-text {
  width: 76%;
}
.skeleton-agenda-block__line--secondary ion-skeleton-text {
  width: 48%;
  height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/agenda/skeleton-agenda-block/skeleton-agenda-block.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;AACJ;AACI;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACN;AAEI;EACE,YAAA;AAAN;AAIE;EACE,SAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;AAKI;EACE,SAAA;EACA,YAAA;AAHN;AAMI;EACE,UAAA;AAJN;AAOI;EACE,UAAA;EACA,YAAA;AALN","sourcesContent":[".skeleton-agenda-block {\n  margin-bottom: 15px;\n  --padding-start: 16px;\n\n  &__date {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    width: 48px;\n    margin-inline-end: 12px;\n\n    ion-skeleton-text {\n      margin: 0;\n      width: 100%;\n      height: 16px;\n      border-radius: 4px;\n    }\n\n    .skeleton-agenda-block__date-line {\n      height: 12px;\n    }\n  }\n\n  &__label {\n    margin: 0;\n  }\n\n  &__line {\n    margin: 0 0 8px;\n\n    ion-skeleton-text {\n      margin: 0;\n      height: 16px;\n    }\n\n    &--primary ion-skeleton-text {\n      width: 76%;\n    }\n\n    &--secondary ion-skeleton-text {\n      width: 48%;\n      height: 14px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
